import styled from '@emotion/styled';
import {
  DropdownMenuContent,
  DropdownMenuItem,
} from '@radix-ui/react-dropdown-menu';
import { Stack, Text } from '@pairy/pds-react';

export const TriggerButton = styled(Stack)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.zinc_200};
  border-radius: 4px;
  transition: all 0.15s ease-in-out;

  &:hover {
    background-color: ${({ theme }) => theme.colors.zinc_200};
  }
`;

export const VersionDropdownContent = styled(DropdownMenuContent)`
  position: relative;
  top: 10px;
  left: 70px;

  display: flex;
  flex-direction: column;
  padding: 8px;
  border: 1px solid ${({ theme }) => theme.colors.zinc_200};
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
  box-shadow: ${({ theme }) => theme.elevation.md};
  gap: 4px;
`;

export const DropDownItem = styled(DropdownMenuItem)`
  display: flex;
  width: 335px;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px;
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.zinc_300};
  outline: none;
  transition: all 0.15s ease-in-out;

  &:hover {
    background-color: ${({ theme }) => theme.colors.zinc_100};
    color: ${({ theme }) => theme.colors.zinc_400};
  }
`;

export const SelectedDropDownItem = styled(DropdownMenuItem)`
  display: flex;
  width: 335px;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px;
  background-color: ${({ theme }) => theme.colors.skyblue_50};
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.skyblue_400};
  outline: none;

  transition: all 0.15s ease-in-out;
  &:hover {
    background-color: ${({ theme }) => theme.colors.zinc_100};
    color: ${({ theme }) => theme.colors.zinc_400};
  }
`;

export const FileNameText = styled(Text)`
  max-width: 270px;
  color: ${({ theme }) => theme.colors.zinc_400};
  transition: all 0.15s ease-in-out;
  &:hover {
    color: ${({ theme }) => theme.colors.zinc_500};
  }
`;
